module.exports = __webpack_public_path__ + "static/img/par12.8a2a614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par12.png
// module id = R4b+
// module chunks = 0